const STORAGE_KEY = 'lazynecro.autosave'
const SAVE_VERSION = 1

export default class SaveSystem
{
    constructor(_state)
    {
        this.state = _state
        this.interval = window.setInterval(() => this.save(), 2000)
        window.addEventListener('pagehide', () => this.save())
        document.addEventListener('visibilitychange', () =>
        {
            if(document.visibilityState === 'hidden')
                this.save()
        })
        this.save()
    }

    static load()
    {
        try
        {
            const raw = window.localStorage.getItem(STORAGE_KEY)
            if(!raw)
                return null
            const save = JSON.parse(raw)
            return save.version === SAVE_VERSION && save.state && typeof save.state === 'object' ? save.state : null
        }
        catch
        {
            return null
        }
    }

    save()
    {
        try
        {
            window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
                version: SAVE_VERSION,
                savedAt: Date.now(),
                state: this.state.toJSON()
            }))
            return true
        }
        catch
        {
            return false
        }
    }
}
